import { Stack } from '@mui/material';
import { SidebarNote } from 'features/augmented-writing/augmented-writing.types';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import NoteItem from './sidebar-notes-item';
interface Props {
  sidebarNotes: SidebarNote[];
  disableBorder?: boolean;
  dense?: boolean;

  onCategoryClicked(category: any, sidebarNote: SidebarNote, manual?: boolean): void;
}

const NotesList: React.FC<Props> = ({ sidebarNotes, disableBorder, dense, onCategoryClicked }) => {
  const [sortedNotes, setSortedNotes] = useState<SidebarNote[]>([]);
  const [expanded, setExpanded] = useState<string | false>(false);

  useEffect(() => {
    const levelOrder = [1, 0, -1];
    const tempNotes = _.sortBy(sidebarNotes, (note) => {
      return levelOrder.indexOf(note.level);
    });
    setSortedNotes(tempNotes);

    if (expanded && !sidebarNotes.map((note) => note.key).includes(expanded)) {
      setExpanded(false);
    } else if (expanded) {
      const foundNote = sidebarNotes.find((note) => note.key === expanded);

      if (!_.isNil(foundNote)) {
        onCategoryClicked(expanded, foundNote, true);
      }
    }
  }, [sidebarNotes]);

  const handleExpandNote = (key: string, sidebarNote: SidebarNote) => {
    return () => {
      if (key === expanded) {
        setExpanded(false);
      } else {
        setExpanded(key);
      }
      onCategoryClicked(key, sidebarNote);
    };
  };

  return (
    <Stack direction={'column'} gap={dense ? '8px' : { xs: '16px', lg: '8px', xl: '16px' }}>
      {sortedNotes.map((note, index) => (
        <NoteItem key={index} sidebarNote={note} expanded={expanded} disableBorder={disableBorder} handleExpandNote={handleExpandNote} />
      ))}
    </Stack>
  );
};

export default NotesList;
